import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import {GroupedData} from "../../data-structures/group"
import CustomFieldsManager from "../../gd/manager/custom-fields-manager"
import Field1ToField2Converter from "../../fields3/fields-converter-1-2"
import FieldsFactory from "../../fields3/fields-factory"
import FieldCrmAccount from "../../fields3/system/crm/account/crm-account";
import FieldEstimatedCostInternal from "../../fields3/generic/finance/cost-estimated/estimated-cost-internal";
import FieldEstimatedCostExternal from "../../fields3/generic/finance/cost-estimated/estimated-cost-external";
import FieldProjectEstimateTasks from "../../fields3/system/project/estimate/estimate-tasks";
import FieldProjectEstimate from "../../fields3/system/project/estimate/estimate";
import FieldDate from "../../fields3/generic/datetime/date/date";
import FieldProjectPriority from "../../fields3/system/project/priority/priority";
import FieldProjectOwner from "../../fields3/system/project/owner/project-owner";
import FieldProjectUsers from "../../fields3/system/project/users/users";
import FieldProjectStartDate from "../../fields3/system/project/dates/start/start-date";
import FieldProjectEndDate from "../../fields3/system/project/dates/end/end-date";
import FieldProjectDurationWorkdays from "../../fields3/system/project/duration/duration-workdays";
import FieldProjectDurationCalendar from "../../fields3/system/project/duration/duration-calendar";
import FieldProjectProgress from "../../fields3/system/project/progress/progress";
import FieldProjectProgressItems from "../../fields3/system/project/progress-items/progress-items";
import FieldText from "../../fields3/generic/text/text";
import FieldProjectTotalOpenAll from "../../fields3/system/project/total-open-all/total-open-all";
import FieldProjectColor from "../../fields3/system/project/color/color";
import FieldProjectStartEnd from "../../fields3/system/project/dates/start-end/start-end";
import FieldProjectHealth from "../../fields3/system/project/health/health";
import FieldPredecessors from "../../fields3/generic/dependency/predecessors/predecessors"
import FieldSuccessors from "../../fields3/generic/dependency/successors/dependants"
import FieldProjectStatus from "../../fields3/system/project/status/project-status";
import FieldProjectProgressTasks from "../../fields3/system/project/progress-tasks/progress-tasks";
import FieldProjectType from "../../fields3/system/project/type/type"
import FieldProjectParent from "../../fields3/system/project/parent/parent"
import FieldProjectAccess from "../../fields3/system/project/access/project-access"
import FieldProjectIcon from "../../fields3/system/project/icon/icon"
import FieldProjectColorIcon from "../../fields3/system/project/color-icon/color-icon"
import FieldProjectSystemStatus from "../../fields3/system/project/system-status/system-status"
import FieldString from "../../fields3/generic/string/string";
import FieldProjectAccessMode from "../../fields3/system/project/access-mode/access-mode";

const baseConfig = [

    { fieldId: 'id',                                            type: FieldType.PROJECT },
    { fieldId: 'statusId',          label: 'Status',            type: FieldType.PROJECT_STATUS },
    { fieldId: 'systemStatus',      label: 'System status',     type: FieldType.PROJECT_SYSTEM_STATUS },

    { fieldId: 'name',              label: 'Name',              type: FieldType.STRING },
    {
        fieldId                 : 'statusComments',
        label                   : 'Status comments',
        type                    : FieldType.TEXT,
        noDefaultPaddingMargin  : true
    },
    {
        fieldId         : 'color',
        type            : FieldType.PROJECT_COLOR
    },
    {
        fieldId         : 'projectIcon',
        label           : 'Icon',
        type            : FieldType.PROJECT_ICON
    },
    {
        fieldId         : 'projectColorIcon',
        label           : 'Color / Icon',
        type            : FieldType.PROJECT_COLOR_ICON
    },
    {
        fieldId         : 'ownerUserId',
        label           : 'Project owner',
        type            : FieldType.PROJECT_OWNER,
        icon            : 'i5-user'
    },
    {
        fieldId: 'health',
        label: 'Health',
        type: FieldType.PROJECT_HEALTH
    },
    {
        fieldId: 'momentCreated',
        label: 'Date Created',
        type: FieldType.PROJECT_MOMENT_CREATED
    },
    {
        fieldId: 'deadline',
        label: 'Deadline',
        type: FieldType.PROJECT_DEADLINE
    },
    {
        fieldId: 'startEnd',
        label: 'Start-End',
        type: FieldType.PROJECT_START_END
    },
    {
        fieldId     : 'startDate',
        label       : 'Start date',
        type        : FieldType.PROJECT_START,
        icon        : 'i5-date-start'
    },
    {
        fieldId     : 'endDate',
        label       : 'End date',
        type        : FieldType.PROJECT_END,
        icon        : 'i5-date-end'
    },
    {
        fieldId         : 'parentId',
        label           : 'Parent Project',
        type            : FieldType.PROJECT_PARENT
    },
    {
        fieldId         : 'projectType',
        label           : 'Project Type',
        type            : FieldType.PROJECT_TYPE
    },
    { fieldId: 'priority',          label: 'Priority',          type: FieldType.PROJECT_PRIORITY,   noDefaultPaddingMargin: true},
    {
        fieldId     : 'estimate',
        label       : 'Estimate',
        type        : FieldType.PROJECT_ESTIMATE
    },
    {
        fieldId     : 'estimateTasks',
        label       : 'Estimate, tasks total',
        type        : FieldType.PROJECT_ESTIMATE_TASKS
    },

    { fieldId: 'progress',          label: 'Progress',          type: FieldType.PROJECT_PROGRESS },

    { fieldId: 'access',                                        type: FieldType.PROJECT_ACCESS},

    { fieldId: 'dateCreated',       label: 'Date created',      type: FieldType.DATE},
    { fieldId: 'description',       label: 'Description',        icon:'i5-calendar',         type: FieldType.TEXT},
    {fieldId: 'crmAccountId',       label: 'CRM Account',       type: FieldType.CRM_ACCOUNT},

    {
        // has no model field! which is ok ... used in table only
        fieldId         : 'estimatedCostInternal',
        type            : FieldType.ESTIMATED_COST_INTERNAL,
        label           : 'Estimated labor cost'
    },
    {
        // has no model field! which is ok ... used in table only
        fieldId         : 'estimatedCostExternal',
        type            : FieldType.ESTIMATED_COST_EXTERNAL,
        label           : 'Estimated service cost'
    },
    {
        fieldId         : 'localTemplateId',
        type            : FieldType.PROJECT_TEMPLATE,
        label           : 'Project Type'
    },
    {
        fieldId         : 'users',
        type            : FieldType.PROJECT_USERS
    },

    {
        fieldId     : 'durationWorkdays',
        label       : 'Duration, workdays',
        type        : FieldType.PROJECT_DURATION_WORKDAYS,
    },
    {
        fieldId     : 'durationCalendar',
        label       : 'Duration, calendar',
        type        : FieldType.PROJECT_DURATION_CALENDAR,
    },
    {
        fieldId: 'progressItems',
        label: 'Progress, items',
        type: FieldType.PROJECT_PROGRESS_ITEMS
    },
    {
        fieldId     : 'totalOpenAll',
        type        : FieldType.PROJECT_TOTAL_OPEN_ALL
    },
    {
        fieldId         : 'predecessors',
        type            : FieldType.PREDECESSORS,
        label           : 'Depends on'
    },
    {
        fieldId         : 'successors',
        type            : FieldType.SUCCESSORS,
        label           : 'Dependants'
    },
    {
        fieldId        : 'progressTasks',
        type            : FieldType.PROJECT_PROGRESS_TASKS,
    },

    {
        fieldId                 : 'url',
        label                   : 'URL',
        type                    : FieldType.TEXT,
        noDefaultPaddingMargin  : true
    },
    {
        fieldId                 : 'embedCode',
        label                   : 'URL or Embed code',
        type                    : FieldType.TEXT,
        noDefaultPaddingMargin  : true
    },
    {
        fieldId                 : 'accessMode',
        type                    : FieldType.PROJECT_ACCESS_MODE,
        label                   : 'Access Mode',
    }
]

export default class ProjectFields extends FieldsCollection {

    private isCompanyManager: boolean = false



    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.PROJECT);

        this.isCompanyManager = gd.ac.check.company.isManager(gd.companyId)
        this.initAllCustomFields()



    }

    get name()                          { return this.get('name') as FieldString}
    get statusId()                      { return this.get('statusId') as FieldProjectStatus}
    get systemStatus()                  { return this.get('systemStatus') as FieldProjectSystemStatus}
    get deadline()                      { return this.get('deadline') as FieldDate}
    get startDate()                     { return this.get('startDate') as FieldProjectStartDate}
    get endDate()                       { return this.get('endDate') as FieldProjectEndDate}
    get startEnd()                      { return this.get('startEnd') as FieldProjectStartEnd}
    get momentCreated()                 { return this.get('momentCreated') as FieldDate }
    get crmAccountId()                  { return this.get('crmAccountId') as FieldCrmAccount}
    get estimatedCostInternal()         { return this.get('estimatedCostInternal') as FieldEstimatedCostInternal}
    get estimatedCostExternal()         { return this.get('estimatedCostExternal') as FieldEstimatedCostExternal}
    get estimateTasks()                 { return this.get('estimateTasks') as FieldProjectEstimateTasks}
    get estimate()                      { return this.get('estimate') as FieldProjectEstimate }
    get priority()                      { return this.get('priority') as FieldProjectPriority }
    get projectOwner()                  { return this.get('ownerUserId') as FieldProjectOwner }
    get users()                         { return this.get('users') as unknown as FieldProjectUsers }
    get durationWorkdays()              { return this.get('durationWorkdays') as FieldProjectDurationWorkdays}
    get durationCalendar()              { return this.get('durationCalendar') as FieldProjectDurationCalendar}
    get progress()                      { return this.get('progress') as FieldProjectProgress}
    get progressItems()                 { return this.get('progressItems') as FieldProjectProgressItems }
    get progressTasks()                 { return this.get('progressTasks') as FieldProjectProgressTasks }
    get statusComments()                { return this.get('statusComments') as FieldText }
    get totalOpenAll()                  { return this.get('totalOpenAll') as FieldProjectTotalOpenAll }
    get color()                         { return this.get('color') as FieldProjectColor }
    get projectIcon()                   { return this.get('projectIcon') as FieldProjectIcon }
    get projectColorIcon()              { return this.get('projectColorIcon') as FieldProjectColorIcon }
    get health()                        { return this.get('health') as FieldProjectHealth }
    get predecessors()                  { return this.get('predecessors') as FieldPredecessors}
    get successors()                    { return this.get('successors') as FieldSuccessors}
    get projectType()                   { return this.get('projectType') as FieldProjectType}
    get parentId()                      { return this.get('parentId') as FieldProjectParent}
    get access()                        { return this.get('access') as FieldProjectAccess}
    get accessMode()                    { return this.get('accessMode') as FieldProjectAccessMode}

    // property fields
    get url()                           { return this.get('url') as FieldText }

    // view fields
    get embedCode()                     { return this.get('embedCode') as FieldText }

    // Used at least in TABLE view... chto mne ne nravitsya esli chestno
    getFieldByField1Id(id:string) {
        let res
        switch (id) {
            case FieldType.PROJECT_ESTIMATE             : return this.estimate
            case FieldType.PROJECT_ESTIMATE_TASKS       : return this.estimateTasks
            case gd.const.fields.type.CRM_ACCOUNT       : return this.crmAccountId // need in table
            case FieldType.ESTIMATED_COST_INTERNAL      : return this.estimatedCostInternal // need in table
            case FieldType.ESTIMATED_COST_EXTERNAL      : return this.estimatedCostExternal // need in table
            // case 'noGrouping'                           : res = null; break
            default:
                /* in this case id is customFieldId */
                res = this.get(id);
                return res
        }

    }


    public hasField = (fieldId:fieldId): boolean => {
        return !!_.find(this._fields, field=>field.fieldId === fieldId)
    }

    private isCustomFieldAvailable = (customField:any): boolean => {
        return (this.isCompanyManager || customField.access === gd.const.customFields.access.EVERYONE) &&
            _.intersection(customField.params.scope, [gd.const.customFields.scope.PROJECT]).length > 0 &&
            !customField.isDeleted
    }

    public addCustomField(customField:any) {
        if (!this.isCustomFieldAvailable(customField)) return

        const field2Config = Field1ToField2Converter.getField2Config(customField.id)
        if (field2Config                                                // field config successfully created
            && !this.hasField(field2Config.fieldId)                     // field with same ID does not exist in this (ProjectFields) fields collection
            && gd.session.customFields.get(field2Config?.fieldId)) {    // custom field exists in session
            this.addField(FieldsFactory.get(field2Config))
        }
    }

    public initAllCustomFields() {
        const customFields = CustomFieldsManager.getOrganizationCustomFields(gd.companyId, [gd.const.customFields.scope.PROJECT])
        _.map(customFields, customField=>{this.addCustomField(customField)})
    }

    get structureGroupBy():GroupedData {
        return [
            {
                value   : 'generic',
                label   : 'Generic',
                type    : 'system',
                items   : [
                    this.get('statusId'),
                    this.get('priority'),
                    this.get('statusComments'),
                    this.get('health'),
                ]
            },
            {
                value   : 'dates',
                label   : 'Dates',
                type    : 'system',
                items   : [
                    this.get('startEnd'),
                    this.get('deadline'),
                ]
            },
            {
                value   : 'estimate',
                label   : 'Estimate',
                type    : 'system',
                items   : [
                    this.get('estimate'),
                ]
            },
            {
                value   : 'progress',
                label   : 'Progress',
                type    : 'system',
                items   : [
                    this.get('progress'),
                ]
            }
        ]
    }

    structureColorCoding():GroupedData {
        return [
            {
                value   : 'generic',
                label   : 'System fields',
                type    : 'system',
                items   : [
                    this.get('color'),
                    this.get('statusId'),
                    this.get('priority'),
                    this.get('health'),
                ]
            }
        ]
    }
}
